// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"63":"SuperAdminDashboard","175":"NoServer","704":"changePassword","939":"AppMain"}[chunkId] || chunkId) + "." + {"22":"8c1f67d5","63":"1454ca9b","175":"ae4aab7e","704":"72b907bf","939":"8bab6019"}[chunkId] + ".chunk.css";
};